module.exports = __webpack_public_path__ + "static/media/workAntihumidity3.69dd2af6.jpg";